import { render, staticRenderFns } from "./demand-detail.vue?vue&type=template&id=407af0c1&scoped=true"
import script from "./demand-detail.vue?vue&type=script&lang=js"
export * from "./demand-detail.vue?vue&type=script&lang=js"
import style0 from "./demand-detail.vue?vue&type=style&index=0&id=407af0c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407af0c1",
  null
  
)

export default component.exports